import { SINGLE_NUMERIC } from './_argShapes';
import { STUB_NOT_IMPLEMENTED } from './_stubs';
import type { EffectEntry } from './types';

export const crush: EffectEntry = {
  kind: 'crush',
  category: 'effect',
  family: 'distortion',
  doc: 'bit-crush to N bits (2 destroyed, 8 grimy, 16 clean)',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('crush', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('crush', 'fromAst'),
};

export const coarse: EffectEntry = {
  kind: 'coarse',
  category: 'effect',
  family: 'distortion',
  doc: 'sample-rate reduction (1 clean, 4 lo-fi, 16 bitcrushed)',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('coarse', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('coarse', 'fromAst'),
};

export const distort: EffectEntry = {
  kind: 'distort',
  category: 'effect',
  family: 'distortion',
  doc: 'waveshaping distortion (0 clean, 0.5 warm, 1+ heavy)',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('distort', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('distort', 'fromAst'),
};

export const shape: EffectEntry = {
  kind: 'shape',
  category: 'effect',
  family: 'distortion',
  doc: 'soft-clip saturation (0–1, gentler than distort)',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('shape', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('shape', 'fromAst'),
};

export const squiz: EffectEntry = {
  kind: 'squiz',
  category: 'effect',
  family: 'distortion',
  doc: 'ring-mod style squash (0 clean, 1+ aggressive)',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('squiz', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('squiz', 'fromAst'),
};

export const comb: EffectEntry = {
  kind: 'comb',
  category: 'effect',
  family: 'distortion',
  doc: 'comb filter pitch (0–1, short = metallic)',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('comb', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('comb', 'fromAst'),
};
